// Dependencies
import { all } from 'redux-saga/effects';

// Components
import vidFleetVideoSaga from 'Modules/.common/components/VidFleetVideo/redux/saga';
import sharedMediaSaga from 'Modules/.common/components/SharedMedia/redux/saga';
import accountInformationSaga from 'Modules/.common/components/AccountInformation/redux/saga';
import smartwitnessVideoSaga from 'Modules/.common/components/SmartWitnessVideo/redux/saga';
import iconPickerSaga from 'Modules/.common/components/IconPicker/redux/saga';
import SliderRangePanel from 'Modules/.common/components/SliderRangePanel/redux/saga';
import entityPickerSaga from 'Modules/.common/components/EntityPicker/redux/saga';
// Merge sagas
export default function* rootSaga() {
  yield all([
    vidFleetVideoSaga(),
    sharedMediaSaga(),
    accountInformationSaga(),
    smartwitnessVideoSaga(),
    iconPickerSaga(),
    SliderRangePanel(),
    entityPickerSaga()
  ]);
}